<script>
   /*************************************************************
   * ResultsTable                                               *
   * -------------------------                                  *
   * shows table with SIMCA results for training and PV-sets    *
   **************************************************************/

   // main properties of the whole app
   export let simcares;
   export let ncomp;

   $: cal = simcares ? simcares.cal : null;
   $: pv = simcares ? simcares.pv : null;
</script>


{#if cal && pv}
<table>
   <tr>
      <th></th>
      <th>Cal</th>
      <th>PV</th>
   </tr>
   <tr>
      <td class="label">Objects</td>
      <td>{cal.nrows}</td>
      <td>{pv.nrows}</td>
   </tr>
   <tr>
      <td class="label">Extremes</td>
      <td>{cal.v[ncomp - 1].cnum.extreme}</td>
      <td>{pv.v[ncomp - 1].cnum.extreme}</td>
   </tr>
   <tr>
      <td class="label">Outliers</td>
      <td>{cal.v[ncomp - 1].cnum.outliers}</td>
      <td>{pv.v[ncomp - 1].cnum.outliers}</td>
   </tr>
   <tr>
      <td class="label">Sensitivity</td>
      <td>{cal.stat.sensitivity[ncomp - 1].toFixed(3)}</td>
      <td>{pv.stat.sensitivity[ncomp - 1].toFixed(3)}</td>
   </tr>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>